export const VdpFinanceLease = {
  props: ['financeData',
  'leaseData',
  'vehiclesPrice',
  'cashRebate',
  'leaseRebate',
  'lang',
  'msrpData',
  'residualMsrp',
  'financeUsedData',
  'vehicleCondition',
  'vehicleCertified',
  'vehicleModel',
  'vehicleYear',
  'lbxSettingFinanceFreq',
  'stock',
  'customDownPayment',
  'provinceTax',
  'customNewFinanceData',
  'customNewLeaseData', 
  'useMsrp',
  'useMsrpUsed'],
  data() {
    return {
      cashRebateValue: (Math.abs(this.cashRebate)),
      msrp: this.msrpData,
      vehiclePriceLease: (this.useMsrp ? this.msrpData : this.vehiclesPrice) - (this.leaseRebate || 0),
      vehiclePrice: this.vehicleCondition == 'New' ? (this.useMsrp ? this.msrpData : this.vehiclesPrice) : (this.useMsrpUsed ? this.msrpData : this.vehiclesPrice),
      existPrice: true,
      financeDetailsVisibility: false,
      financeAddIcon: '+',
      leaseDetailsVisibility: false,
      leaseAddIcon: '+',
      downPayment: this.customDownPayment ? this.customDownPayment : 0,
      tradeInValue:0,
      selectedNum: -1,
      financeStatus: 'closed',
      leaseStatus: 'closed',
      provinceTaxValue: this.provinceTax ? (1 + (this.provinceTax / 100)) : 1.13,
      kilometersAllowance: 25000,
      costOfBorrowing: 0,
      costOfBorrowingLease: 0,
    }
  },
  mounted() {
    this.$root.$on('closeFinanceDetailsExcept', (exceptUid) => {
      if (exceptUid !== this._uid) {
        this.financeDetailsVisibility = false;
        this.financeStatus = 'closed';
        this.financeAddIcon = '+';
        this.leaseDetailsVisibility = false;
        this.leaseStatus = 'closed';
        this.leaseAddIcon = '+';
      }
    });
  },
  beforeDestroy() {
    this.$root.$off('closeFinanceDetailsExcept');
  },
  created: function () {
    if(this.vehiclePriceLease <= 0){
      this.existPrice = false;
    }
  },
  methods: {
    numberFormat(value) {
      return new Intl.NumberFormat(this.lang).format(value);
    },
    usdFormat(value, digits = 0){
      var formatter = new Intl.NumberFormat(this.lang, {
        style: 'currency',
        currency: 'CAD',
        minimumFractionDigits: digits,
    });

      return ( digits != 0) ? formatter.format(value) : formatter.format(Math.floor(value));
    },
      showSection(){
        return Object.keys(this.maxTermItem).length === 0 && this.maxTermItem.constructor === Object
      },
      financeDetails(event){
        event.stopPropagation();
        this.leaseDetailsVisibility = false
        this.financeDetailsVisibility = !this.financeDetailsVisibility;
        this.financeStatus = 'opening'
        if(this.financeAddIcon == '+')
          this.financeAddIcon = '-'
        else
          this.financeAddIcon = '+'
      },
      financeDetailsOff(event){
        event.stopPropagation();
        if (this.financeStatus =='open'){
          this.financeDetailsVisibility = false
          this.financeAddIcon = '+'
          this.financeStatus = 'closed'
        }
        
        if(this.financeStatus == 'opening'){
          this.financeStatus = 'open'
        }
      },
      leaseDetails(event){
        event.stopPropagation();

        this.financeDetailsVisibility = false
        this.leaseDetailsVisibility = !this.leaseDetailsVisibility;
        this.leaseStatus = 'opening'
        if(this.leaseAddIcon == '+')
          this.leaseAddIcon = '-'
        else
          this.leaseAddIcon = '+'
      },
      leaseDetailsOff(event){
        event.stopPropagation();
        
        if (this.leaseStatus =='open'){
          this.leaseDetailsVisibility = false
          this.leaseAddIcon = '+'
          this.leaseStatus = 'closed'
        }
        
        if(this.leaseStatus == 'opening'){
          this.leaseStatus = 'open'
        }
    },
      financeDetailsOpen(event){
        event.stopPropagation();
        this.$root.$emit('closeFinanceDetailsExcept', this._uid);
        this.leaseDetailsVisibility = false;
        this.leaseStatus = 'closed';
        this.leaseAddIcon = '+';
        this.financeDetailsVisibility = false;
        this.financeDetailsVisibility = !this.financeDetailsVisibility;
        this.financeStatus = 'open';
      },
      financeDetailsClose(event){
        event.stopPropagation();
        if (this.financeStatus =='open'){
          this.financeDetailsVisibility = false
          this.financeStatus = 'closed'
        }
        if(this.financeStatus == 'opening'){
          this.financeStatus = 'closed'
        }
    },
      leaseDetailsOpen(event){
        event.stopPropagation();
        this.$root.$emit('closeFinanceDetailsExcept', this._uid);
        this.financeDetailsVisibility = false;
        this.financeStatus = 'closed';
        this.financeAddIcon = '+';
        this.leaseDetailsVisibility = !this.leaseDetailsVisibility;
        this.leaseStatus = 'open';
      },
      leaseDetailsClose(event){
        event.stopPropagation();
        if (this.leaseStatus =='open'){
          this.leaseDetailsVisibility = false
          this.leaseStatus = 'closed'
        }
        if(this.leaseStatus == 'opening'){
          this.leaseStatus = 'closed'
        }
      },
      calculatePayment(){
        if(this.loanTerm == 0)
          return 0;
        if(this.interestRate == 0)
          return (this.remainingVehiclePrice) / this.loanTerm;

        let subTotal = Math.round((((this.remainingVehiclePrice) * (this.interestRate / 1200)) * Math.pow((1 + (this.interestRate / 1200)), this.loanTerm)) / (Math.pow((1 + (this.interestRate / 1200)), this.loanTerm) - 1) * 100) / 100;
        let amountFinanced = (Math.round(subTotal * this.loanTerm) * 100 / 100);
        this.costOfBorrowing = (amountFinanced - this.remainingVehiclePrice) * ( this.provinceTaxValue);
        return Number((subTotal).toFixed(2));
    },
    allowanceMileages() {
      let leaseMT = JSON.parse(this.lease.metadata);
      if (!leaseMT) return null;
  
      let obj = leaseMT.adjustments.adjustment ? leaseMT.adjustments.adjustment : leaseMT.adjustments;
  
      for (const prop in obj) {
          if (prop === '0') {
              this.kilometersAllowance = obj[prop]["mileage"];
              return this.kilometersAllowance;
          }
      }
    },
    leaseAdjustment(){
        if (!this.lease.metadata) {
          if (this.lease.length > 0) {
            let objectMeta = JSON.parse(JSON.stringify(this.lease[this.lease.length-1].metadata));
            let object = JSON.parse(objectMeta);
            if(object.adjustments.adjustment && object.adjustments.adjustment.length > 0){
              return object.adjustments.adjustment[0].adjustment;
            }else if(object.adjustments && object.adjustments.length > 0){
              return object.adjustments[0].adjustment;
            } 
          } else {
            return 0;
          }
        }
                

        this.kilometersAllowance = this.allowanceMileages();
        let objectMeta = JSON.parse(JSON.stringify(this.lease.metadata));
        let object = JSON.parse(objectMeta);
        if(object.adjustments.adjustment && object.adjustments.adjustment.length > 0){
          return object.adjustments.adjustment[0].adjustment;
        }else if(object.adjustments && object.adjustments.length > 0){
          return object.adjustments[0].adjustment;
        }
      },
      residualTerm(){
        if(this.lease && this.lease[0] && this.lease[0].residual && this.lease[0].residual > 0){
          // console.log('Residual '+(this.msrp * (this.lease[0].residual / 100)).toFixed(2));
          return (this.residualBase * (this.lease[0].residual / 100)).toFixed(2);
        }else{
          if(this.lease.length <= 0){
              return 0;
          }
          if (this.selectedNum <= -1) {

            if (!this.lease.metadata)
              return 0;
            else {
              let objectMeta = JSON.parse(JSON.stringify(this.lease.metadata));
              let object = JSON.parse(objectMeta);

              // console.log('Residual '+(this.msrp * (object.residual.value / 100)).toFixed(2));
              //console.log("Lease Adjustemnt: " + this.leaseAdjustment());
              if (!object.residual)
                return 0;
              else {
                return (this.residualBase * ( (object.residual.value+this.leaseAdjustment()) / 100)).toFixed(2);
              }
            }
            
          }
          let objectMeta = JSON.parse(JSON.stringify(this.lease[this.selectedNum].metadata));
          let object = JSON.parse(objectMeta);

          // console.log('Residual '+(this.msrp * (object.residual.value / 100)).toFixed(2)); 
          //console.log(object);
          
          if(!object.residual)
            return 0;
          else {
            return (this.residualBase * ((object.residual.value+this.leaseAdjustment()) / 100)).toFixed(2);
          }
        }
      },
      depretiationLease(){
        return ((this.remainingVehiclePriceLease - this.residualTerm()) / this.loanTermLease).toFixed(2)
      },
      moneyFactorLease(){
        return (this.interestRateLease / 2400)
      },
      financingFeeLease(){
        let price = parseFloat(this.remainingVehiclePriceLease);
        let presidual = parseFloat(this.residualTerm());
        return ((presidual + price) * this.moneyFactorLease()).toFixed(2)
      },
      monthlyLease(){
        if(this.loanTermLease == 0)
          return 0;


        /**** aquie esta el lio  */

        let payment = this.leasePayment(parseFloat(this.remainingVehiclePriceLease), parseFloat(this.residualTerm()));
        let amountFinanced = this.remainingVehiclePriceLease - this.residualLease;

        this.costOfBorrowingLease = ((payment * this.loanTermLease) - amountFinanced);

        if (this.costOfBorrowingLease < 0)
          this.costOfBorrowingLease = 0;

        return payment
      },
      // Pago adelantado (el primero se paga al firmar), igual que el desk de la financiera.
      leasePayment(capCost, residual) {
        const term = parseFloat(this.loanTermLease) || 0;
        if (term <= 0)
          return 0;
        const rate = (parseFloat(this.interestRateLease) || 0) / 1200;
        if (rate <= 0)
          return (capCost - residual) / term;
        const discount = Math.pow(1 + rate, -term);
        return (capCost - residual * discount) * rate / (1 - discount) / (1 + rate);
      },
      biWeekley(){
        return (((this.monthlyLease() * 12) / 52) * 2).toFixed(2)
      },
      weekley(){
        return ((this.monthlyLease() * 12) / 52).toFixed(2)
      },
    costOfCredit() {
       return (this.obligation - this.vehiclePriceLease);
      },
      priceInRange(item, price){
        var min = parseFloat(item.minprice) || 0;
        var max = parseFloat(item.maxprice) || 0;
        var vehiclePrice = parseFloat(price) || 0;

        if(min > 0 && vehiclePrice < min) return false;
        if(max > 0 && vehiclePrice > max) return false;

        return true;
      },
      financeRateCPO(financeCPO,year,model,price){
        var selected = {};
        var currentYear = new Date().getFullYear();
        var rules = Object.values(financeCPO || {}).filter(item => item && this.priceInRange(item, price));

        if(!this.financeUsedData.modelFinancing){
            rules.forEach(item => {
              if(item && model && item.models && item.models.toLowerCase().indexOf(model.toLowerCase()) !== -1){
                if(year >= item.startyear && year <= item.endyear){
                  selected = item;
                }
              }
            })
            
            if(Object.keys(selected).length === 0) {
              rules.forEach(item => {
                if(item && model && item.models && item.models.toLowerCase().indexOf("other") !== -1){
                  if(year >= item.startyear && year <= item.endyear){
                    selected = item;
                  }
                }
              })
            }
        }else{
            rules.forEach(item => {
                //console.log(item);
                if(item && model && item.models && item.isCPO && item.models.toLowerCase().indexOf(model.toLowerCase()) !== -1){
                  if(year >= item.startyear && year <= item.endyear){
                    selected = item;
                  }
                }
             });

             if(Object.keys(selected).length === 0) {
                rules.forEach(item => {
                  if(item && model && item.models && item.isCPO && item.models.toLowerCase().indexOf("all") !== -1){
                    if(parseInt(item.startyear) <= 0 || parseInt(item.endyear) <= 0){
                        if( year >= (currentYear - Math.abs(item.startyear))  && year <= (currentYear - Math.abs(item.endyear)) )
                            selected = item;
                    }else{
                        if(year >= item.startyear && year <= item.endyear)
                            selected = item;
                    }

                  }
                })
              }
        }

        return selected;
      }
    },
  computed: {
    obligation(){
      return ((this.vehiclePrice *  ( this.provinceTaxValue)) + this.costOfBorrowing);
    },
    obligationLease(){
      return ((this.vehiclePrice *  ( this.provinceTaxValue)) + this.costOfBorrowingLease);
    },
    // Base the lease residual % applies to: the feed's residualizable MSRP
    // (no freight or dealer fees), else the sale price as before. Without a
    // price it keeps the old base: on a $0 cap cost the lease would go negative.
    residualBase() {
      const residualMsrp = parseFloat(this.residualMsrp) || 0;
      const price = parseFloat(this.useMsrp ? this.msrpData : this.vehiclesPrice) || 0;
      return residualMsrp > 0 && price > 0 ? residualMsrp : this.msrp;
    },
    lease(){
      if(this.leaseData.term > 0 || this.customNewLeaseData == null) {
        return this.leaseData; }
      else {
        return this.customNewLeaseData;
      }
    },
    residualLease() {
      if (!this.lease)
        return 0; 

      var metadata = null;
      try {
        metadata = this.lease.metadata;
        return this.residualBase * (parseFloat(JSON.parse(metadata).residual.value) + this.leaseAdjustment()) / 100;
      }
      catch (e) {
        return 0;
      }
    },
     remainingVehiclePrice() {
      var downPaymentN;
      var tradeInValueN;

      if (this.downPayment) {
        downPaymentN = (this.downPayment.length > 0) ? parseInt(this.downPayment) : 0;
      } else {
        downPaymentN = 0;
      }

      if (this.tradeInValue) {
        tradeInValueN = (this.tradeInValue.length > 0) ? parseInt(this.tradeInValue) : 0;
      } else {
        tradeInValueN = 0;
      }
      var vehiclePrice = parseInt(this.vehiclePrice);
      var result = vehiclePrice;

       let provinceDealerTax = this.provinceTaxValue;
      this.isTaxed ? result = result * provinceDealerTax : result;

      if(tradeInValueN || downPaymentN) {
        if (tradeInValueN) {
          result = result - tradeInValueN;
        }

        if (downPaymentN) {
          result = (result) -  (downPaymentN / this.provinceTaxValue) ;
        }
      }
      else{
        //result = (result * this.provinceTaxValue);
      }


      return result;
    },
    remainingVehiclePriceLease() {
      var downPaymentN;
      var tradeInValueN;

      if (this.downPayment) {
        downPaymentN = (this.downPayment.length > 0) ? parseInt(this.downPayment) : 0;
      } else {
        downPaymentN = 0;
      }

      if (this.tradeInValue) {
        tradeInValueN = (this.tradeInValue.length > 0) ? parseInt(this.tradeInValue) : 0;
      } else {
        tradeInValueN = 0;
      }
      var vehiclePrice = parseInt(this.vehiclePriceLease);
      var result = vehiclePrice;

      let provinceDealerTax = this.provinceTaxValue;
      this.isTaxed ? result = result * provinceDealerTax : result;

      if(tradeInValueN || downPaymentN) {
        if (tradeInValueN) {
          result = result - tradeInValueN;
        }

        if (downPaymentN) {
          result = (result) -  (downPaymentN / this.provinceTaxValue) ;
        }
      }

      return result;
    },
        maxTermItem(){
          if(!(this.finance instanceof Array))
            return this.finance;
        
            var currentYear = new Date().getFullYear();
            let max = 0;
            let i = 0;
            let z = 0;
            let selected = -1;

          if(this.finance != null) {
            if(!this.financeUsedData.modelFinancing || this.vehicleCondition == 'New'){
                Object.values(this.finance).forEach(item => {
                    if(item.term > max){
                      max = item.term;
                      selected = i;
                    }
                    i++;
                  })
            }else{
                Object.values(this.finance).forEach(item => {
                    if(item.models){
                        if(item.models.toLowerCase().includes(this.vehicleModel.toLowerCase())
                            && this.vehicleYear >= item.startyear 
                            && this.vehicleYear <= item.endyear  
                            && !item.isCPO
                            && this.priceInRange(item, this.vehiclesPrice)){
                                max = item.term;
                                selected = i;
                        }
                    }
                    i++;
                });

                if(selected == -1) {
                    Object.values(this.finance).forEach(item => {
                      if(item && this.vehicleModel 
                              && item.models 
                              && !item.isCPO 
                              && item.models.toLowerCase().indexOf("all") !== -1
                              && this.priceInRange(item, this.vehiclesPrice)){
                        if(parseInt(item.startyear) <= 0 && parseInt(item.endyear) > 0){
                            if( this.vehicleYear >= (currentYear - Math.abs(item.startyear)) && this.vehicleYear <= item.endyear ){
                                max = item.term;
                                selected = z;
                            }
                        }else if(parseInt(item.endyear) <= 0 && parseInt(item.startyear) > 0){
                            if( this.vehicleYear >= item.startyear && this.vehicleYear <= (currentYear - Math.abs(item.endyear)) ){
                                max = item.term;
                                selected = z;
                            }
                        }else if(parseInt(item.endyear) <= 0 && parseInt(item.startyear) <= 0){
                          if( this.vehicleYear >= (currentYear - Math.abs(item.startyear)) && this.vehicleYear <= (currentYear - Math.abs(item.endyear)) ){
                              max = item.term;
                              selected = z;
                          }
                        }else{
                            if(this.vehicleYear >= item.startyear && this.vehicleYear <= item.endyear){
                                max = item.term;
                                selected = z;
                            }
                        }
    
                      }
                      z++;
                    })
                  }
            }

          }
          if(selected == -1)
            return {};
  
          return JSON.parse(JSON.stringify(this.finance[selected]));
        },
        interestRate(){
          var value = this.maxTermItem.value
          if (value > 50 ){
            return (value / 100)
          } else {
            return value;
          }
        },
        loanTerm(){
          return this.maxTermItem.term;
        },
        maxTermItemLease(){
          if(!(this.lease instanceof Array))
            return this.lease;

          let max = 0;
          let i = 0;
          let selected = -1;

          if(this.lease != null) {

              Object.values(this.lease).forEach(item => {
                  if(item.term > max){
                    max = item.term;
                    selected = i;
                  }
        
                  i++;
                })
          }
          
          if(selected == -1)
            return {};
          this.selectedNum = selected

          return JSON.parse(JSON.stringify(this.lease[this.selectedNum]));
        },
        interestRateLease(){
          var value = this.maxTermItemLease.value
          if (value > 50 ){
            return (value / 100)
          } else {
            return value;
          }
        },
        loanTermLease(){
          return this.maxTermItemLease.term;
        },
        finance(){
          if (this.vehicleCondition === 'New') {
            if(this.financeData.term > 0 || this.customNewFinanceData == null)
              return this.financeData;
            else 
              return this.customNewFinanceData;
          }        
          else if(this.vehicleCondition == 'Used' && this.financeUsedData){
            if(this.vehicleCertified && this.financeUsedData && this.financeUsedData.cpo){
                if(!this.financeUsedData.modelFinancing){
                    var cpo = this.financeRateCPO(this.financeUsedData.cpo, this.vehicleYear, this.vehicleModel, this.vehiclesPrice);
                    //console.log(cpo);
                    return cpo;
                }else{
                    var cpo = this.financeRateCPO(this.financeUsedData.financeByModel, this.vehicleYear, this.vehicleModel, this.vehiclesPrice);
                   //console.log(cpo);
                    return cpo;
                }
            }
            else{
                if(this.financeUsedData.specialFinancing && !this.financeUsedData.modelFinancing){

                var currentYear = new Date().getFullYear();
                var yearDiff = currentYear - this.vehicleYear;

                if(this.financeUsedData.yearsForSubfinance && yearDiff <= this.financeUsedData.yearsForSubfinance)
                    return this.financeUsedData.subfinance || {term: 0, value: 0};
                else if(this.financeUsedData.yearsForSubfinance && yearDiff > this.financeUsedData.yearsForSubfinance)
                    return this.financeUsedData.finance || {term: 0, value: 0};
                else
                    return this.financeUsedData.defaultFinance || {term: 0, value: 0};
                }else if(this.financeUsedData.modelFinancing)
                    return this.financeUsedData.financeByModel || {term: 0, value: 0};
                else
                    return this.financeUsedData || {term: 0, value: 0};
            }
          }
          else{
            return {term: 0, value: 0};
          }
        },
        financeTotal(){
          var subTotal = this.calculatePayment();
          switch(this.lbxSettingFinanceFreq){
            case 'Weekly' :
              return Math.round(((subTotal * 12) / 52).toFixed(2));
            case 'Bi-Weekly' :
              return Math.round(((subTotal * 12) / 26).toFixed(2));
            default :
              return Math.round(subTotal.toFixed(2));
          }
        },
        leaseTotal(){
          if(this.leaseData){
            var subTotal = this.monthlyLease();
            switch(this.lbxSettingFinanceFreq){
              case 'Weekly' :
                return Math.round(((subTotal * 12) / 52).toFixed(2));
              case 'Bi-Weekly' :
                return Math.round(((subTotal * 12) / 26).toFixed(2));
              default :
                return Math.round(subTotal.toFixed(2));
            }
          }
          else
            return 0;
        }
      },  
}